/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpRespTopYMAL_similarItems = {
    readonly edges: ReadonlyArray<{
        readonly node: {
            readonly serviceId: string | null;
            readonly categoryPath: string | null;
            readonly categoryCode: string | null;
            readonly browseUrl: string | null;
            readonly title: string | null;
            readonly ecommerceTrackingParams: unknown | null;
            readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemCarousel_item">;
        } | null;
    } | null> | null;
    readonly " $refType": "PdpRespTopYMAL_similarItems";
};
export type PdpRespTopYMAL_similarItems$data = PdpRespTopYMAL_similarItems;
export type PdpRespTopYMAL_similarItems$key = {
    readonly " $data"?: PdpRespTopYMAL_similarItems$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespTopYMAL_similarItems">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespTopYMAL_similarItems",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "moreLikeThisItemEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Item",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "categoryPath",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "categoryCode",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "browseUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ecommerceTrackingParams",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSimilarItemCarousel_item"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "moreLikeThisItemConnection",
  "abstractKey": null
};
(node as any).hash = 'd8c27c70e9cdd9513b7e9424772d659f';
export default node;
